/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {
				$('.banner_slider').slick({
					fade: true,
					autoplay: false,
					autoplaySpeed: 4500,
					arrows: true,
					dots: true,
					prevArrow: '<span class="prev"></span>',
					nextArrow: '<span class="next"></span>'
				});
				$( '.toggle_fullscreen' ).click(function( event ) {
					event.preventDefault();
					$('header.navbar').animate({'margin-top': '-200px'},500);
					$('.site-footer nav').animate({'margin-bottom': '-200px'},500);
					$('.homepage_ctas').animate({'opacity': '0'},500);
					$(this).hide();
					$('body.home').addClass('normal').fadeTo(500, 1);
					$('.toggle_reset').show();
					$('.fullscreen_logo').delay( 1000 ).animate({'opacity': '1'},500);
				});
				$( '.toggle_reset' ).click(function( event ) {
					event.preventDefault();
					$('body').removeClass('normal');
					$('.fullscreen_logo').animate({'opacity': '0'},500);
					$('header.navbar').animate({'margin-top': '0'},500);
					$('.site-footer nav').animate({'margin-bottom': '0'},500);
					$('.homepage_ctas').animate({'opacity': '1'},500);
					$(this).hide();
					$('.toggle_fullscreen').show();
				});
				$('.sub-menu-alike').localScroll({
				    offset: -80,
				    duration: 400,
				    hash: true
				});

				$('.sub-menu-alike a').click(function(){
					$('.sub-menu-alike a').removeClass('selected');
					var fragment = this.getAttribute('href');
					$('.sub-menu-alike a[href=' + fragment + ']').toggleClass('selected');
				});				
				
				$('.next-story').localScroll({
					duration: 400
				});


			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function() {
				// JavaScript to be fired on the home page
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function() {
				// JavaScript to be fired on the about us page
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});
			//if ($(window).width() > 480) {
				var $grid = $('.masonry-grid').masonry({
					// options
					itemSelector: '.grid-item',
					'gutter': 2,
					percentPosition: true
				});
				$grid.imagesLoaded().progress( function() {
				  $grid.masonry('layout');
				});
			//}
			var $section = $('#zoom-buttons');
			$('.map-guide').panzoom({
				minScale: 1,
				maxScale: 6,
				contain: 'invert',
				increment: 0.5,
				easing: "ease-in-out",
				$zoomIn: $section.find(".zoom-in"),
				$zoomOut: $section.find(".zoom-out"),
				$zoomRange: $section.find(".zoom-range"),
				$reset: $section.find(".reset")
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
